import CircularLoading from './CircularLoading';

export default CircularLoading